import { Colors } from "@blueprintjs/core";
import React, { ChangeEvent } from "react";
import { styled } from "styled-components";

interface InputFieldProps {
  mt?: string;
      bradius?: string;
      pd?: string;
  label?: string;
  name: string;
  type: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  inputContainerClass?: string;
  placeholder?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  mt,
  bradius,
  pd,
  label,
  name,
  type,
  value,
  onChange,
  inputContainerClass,
  placeholder = "Please Input",
}) => {

  return (
    <div className={inputContainerClass ?? "mt-xlg"}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <CustomInputField
      mt={mt}
      bradius={bradius}
      pd={pd}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default InputField;

const Label = styled.label`
    font-size: 15px;
    color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY5 : Colors.GRAY1};
`;
const CustomInputField = styled.input<{ mt?: string, bradius?: string, pd?: string }>`
    width: 100%;
    background-color: ${({ theme: { darkMode } }) =>darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
    border: 1px solid ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY3};
    font-size: 15px;
    border-radius: ${({ bradius }) =>bradius ? bradius : "10px"};
    color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY4 : Colors.GRAY2};
    margin-top: ${({ mt }) =>mt ? mt : "3px"};
    padding: ${({ pd }) =>pd ? pd : "10px 15px"};
    &:focus-visible{
      outline: none;
    }
    &::placeholder{
      color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY1};
    }
`;
